import { useLayoutEffect, useState } from "react";
const clickListeners = (element, listener, remove) => {
    if (!remove) {
        element.addEventListener("mousedown", listener);
        element.addEventListener("touchstart", listener);
    }
    else {
        element.removeEventListener("mousedown", listener);
        element.removeEventListener("touchstart", listener);
    }
};
function useOutsideClick(ref, exclude) {
    const [isOutside, setOutside] = useState();
    const setOutsideValue = () => {
        setOutside(!isOutside);
    };
    useLayoutEffect(() => {
        const listener = (event) => {
            const target = event.target;
            const outsideBase = !(ref?.current?.contains(target) ?? false);
            const filteredExclude = exclude?.filter(Boolean) ?? [];
            const next = filteredExclude.length > 0
                ? filteredExclude.every((e) => !(e?.contains(target) ?? false)) && outsideBase
                : outsideBase;
            setOutside((prev) => (prev === next ? prev : next));
        };
        clickListeners(document, listener);
        return () => clickListeners(document, listener, true);
    }, [ref, exclude]);
    return { isOutside, setOutsideValue };
}
export default useOutsideClick;
